/*
 * © Copyright 2014 – 2023 Open Text or one of its affiliates.
 *
 * The only warranties for products and services of Open Text and its affiliates and licensors ("Open Text") are as
 * may be set forth in the express warranty statements accompanying such products and services. Nothing herein should be
 * constituting an additional warranty. Open Text shall not be liable for technical or editorial errors or omissions
 * contained herein.
 *
 * The information contained herein is subject to change without notice.
 */

/* Read from and write to local storage.
 * Catch errors in case the user has disabled local storage.
 */
export const storageItems = {
    ENDPOINT_SESSION_ID: 'ENDPOINT_SESSION_ID',
    LOGIN_PROCESS_ID: 'LOGIN_PROCESS_ID',
    LOGIN_SESSION_ID: 'LOGIN_SESSION_ID',
    TENANT_NAME: 'TENANT_NAME',
    POST_LOGIN_REDIRECT: 'POST_LOGIN_REDIRECT',
    TASK_COMPLETE_REDIRECT: 'TASK_COMPLETE_REDIRECT',
    IS_HOSTED_SAAS: 'IS_HOSTED_SAAS'
};

export function loadStorageItem(name) {
    try {
        return localStorage.getItem(name) || undefined;
    }
    catch (err) {
        // Ignore read errors
        console.error('Local storage read error:', err);
        return undefined;
    }
}

export function saveStorageItem(name, value) {
    try {
        localStorage.setItem(name, value);
    }
    catch (err) {
        // Ignore write errors
        console.error('Local storage write error:', err);
    }
}

export function clearStorageItem(name) {
    try {
        localStorage.removeItem(name);
    }
    catch (err) {
        // Ignore write errors
        console.error('Local storage write error:', err);
    }
}

export function loadSessionStorageItem(name) {
    try {
        return sessionStorage.getItem(name) || undefined;
    }
    catch (err) {
        // Ignore read errors
        console.error('Session storage read error:', err);
        return undefined;
    }
}

export function saveSessionStorageItem(name, value) {
    try {
        sessionStorage.setItem(name, value);
    }
    catch (err) {
        // Ignore write errors
        console.error('Session storage write error:', err);
    }
}

export function clearSessionStorageItem(name) {
    try {
        sessionStorage.removeItem(name);
    }
    catch (err) {
        // Ignore write errors
        console.error('Session storage write error:', err);
    }
}
